// Must match BenchmarkAdjustmentComponentType enum in PITLambdaModel/model/simulations.xml
export const BENCHMARK_ADJUSTMENT_COMPONENTS = [
  { value: "closing_fees", label: "Closing Fee" },
  { value: "refunds_cost", label: "Refund Cost" }
];



// WEBPACK FOOTER //
// ./src/constants/benchmark_adjustment_components.jsx